import React, { useEffect , useState } from 'react'
import Nav from '../../globalComponents/nav/Nav';
import './home.css'
import { useNavigate } from 'react-router-dom'
import ViewProject from '../viewProject/ViewProject';
import Footer from '../../globalComponents/footer/Footer';
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Url from '../url'

function Home() {
    const [ displayProjects, setDisplayProjects ] = useState(false)
    const [token,setToken] = useState(null)
    const [projectsLoaded, setProjectsLoaded] =useState()
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin ] = useState(null)
    const [ projects, setProjects ] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (localStorage.getItem("user")) {
            console.log(Url)
            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ?  setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0,3)+localStorage.getItem("token").slice(4))
        }

        /*
        fetch('../../ssl/server.cert')
            .then(r => r.text())
            .then(text => {
            console.log( text);
            });
        */

            /*
        const options = {
            cert: fs.readFileSync(
                path.resolve(__dirname, './ssl/server.cert'),
                `utf-8`,
                ),
                key: fs.readFileSync(
                    path.resolve(__dirname, './ssl/server.key'),
                    'utf-8',
                    ),
                    passphrase:
                    null,
                    rejectUnauthorized: false,
                    keepAlive: false, // switch to true if you're making a lot of calls from this client
                };
              */  
        //const sslConfiguredAgent = new https.Agent(options);

        fetch(Url+'guest/viewProjects', {
            method: "GET",
            body: null,
            headers: new Headers({
                "Content-Type": "application/json",
            // "authorization": token,
            //agent: sslConfiguredAgent,
            })    
        })
        .then(res => res.json())
        .then(data => {
            console.log("Data here", data)
            
            if (data.allProjects) { 
                setProjects(data)
                setDisplayProjects(true) } 
            else{setDisplayProjects(false)}
            // setTimeout(() => {
            //     setProjects(data)
            // }, 1000);
        })
        .catch(err => console.log(err))
        },[])
    
    return (
        <>
            <Nav></Nav>

            <h1 className='p-title'>Available Projects</h1>
            <hr></hr>
            <div className='container-lg'>
                    {
                        displayProjects ? projects.allProjects.map((projects) => {
                            return (
                                <div key={projects._id} onClick={e=>navigate(`viewProject/${projects._id}`)} className='row pb-4 shadow-5-strong'>

                                    <div className='col-md-3'>
                                        <img className='custom-img' src={projects.imageOfTheProject} alt="" />
                                    </div>

                                    <div className='col-md-6 text-adj'>
                                        <p key={projects._id+"name"}> <strong>{projects.projectName}</strong>
                                            </p>
                                        <p key={projects._id+"decription"}> <strong> Desription: </strong>
                                        {projects.projectDescription}</p>
                                        <p key={projects._id+"deceased"}> <strong>Name of Creator: </strong>
                                            {projects.nameOfOriginalCreator}</p>
                                        
                                    </div>
                                    
                                </div>
                            
                            )
                        }) : <div className='container' ><h1>Server is down for maintenance!</h1></div>
                    }
                    
                
            </div>

            <div style={{marginTop:"150px"}}>

            </div>
            <Footer></Footer>
        </>
    )
}

export default Home